import LockDetailWrapper from "@/modules/accounts/account-detail/LockDetailWrapper";

const LockDetail = () => {
  return <LockDetailWrapper />;
};
export default LockDetail;
